module.exports = __webpack_public_path__ + "static/media/swap.fc41fa84.svg";